import { render, staticRenderFns } from "./BError.vue?vue&type=template&id=5de522b4"
import script from "./BError.vue?vue&type=script&lang=js"
export * from "./BError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports